jQuery.fn.extend({
    getDimensions: function() {
        var w = jQuery(this).width();
        var h = jQuery(this).height();

        return { width : w, height: h };
    }
});

function adjustInputPlaceholders() {
    var placeHolderSupport = ("placeholder" in document.createElement("input"));
    if( !placeHolderSupport ){
        jQuery('[placeholder]').each(function(){
            var placeholder = jQuery(this).attr('placeholder');
            this.onfocus = function(){ if(this.value==placeholder){this.value='';this.className='';} };
            this.onblur  = function(){ if(this.value==''){this.value=placeholder;this.className='';} };
            this.onblur();
        });
    }
}

function popGetDimensions(element) {
    var w = jQuery(element).width();
    var h = jQuery(element).height();

    return { width : w, height: h };
}

var popContainer = null;
var popOverlay = null;
var popContent = null;

var popCurrent = null;

var viewportPersonare = {
    getHeight: function() {
        return jQuery(window).height();
    },
    getWidth: function() {
        return jQuery(window).width();
    },
    getWindowDimensions: function() {
        return {
            width: jQuery(window).width(),
            height: jQuery(window).height()
        };
    },
    _returnOffset : function(l, t) {
        var result = [l, t];
        result.left = l;
        result.top = t;
        return result;
    },
    getScrollOffsets: function() {
        return viewportPersonare._returnOffset(window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
                window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop);
    }
};

var PopObject = function (object) {
    this.properties = object;

    if (typeof(this.properties.events.onComplete) != 'undefined') {
        this.onCompleteMethod = this.properties.events.onComplete.method;
        this.onCompleteArgs = this.properties.events.onComplete.args;

        if (!(this.onCompleteArgs instanceof Array)) {
            this.onCompleteArgs = [this.onCompleteArgs];
        }
    }

    if (this.properties.events.onClose != null && typeof(this.properties.events.onClose.method) != 'undefined') {
        this.onCloseMethod = this.properties.events.onClose.method;

        if (typeof(this.properties.events.onClose.args) != 'undefined') {
            this.onCloseArgs = this.properties.events.onClose.args;
            if (!(this.onCloseArgs instanceof Array)) {
                this.onCloseArgs = [this.onCloseArgs];
            }
        }
    }
};

PopObject.prototype = {
    'properties': null,

    'onCompleteMethod': null,
    'onCompleteArgs':   null,

    'onCloseMethod':    null,
    'onCloseArgs':      null,

    'start': function () {
        popContainer = jQuery('#pop_container');
        popOverlay   = jQuery('#pop_overlay');
        popContent   = jQuery('#pop_content');
    },

    'getParent': function () {
        if (typeof(this.properties.parent) == 'undefined' || this.properties.parent == null) {
            return null;
        }

        return this.properties.parent;
    },

    'configureEvents': function () {
        if (this.getParent() != null) {

            if (this.onCompleteMethod == null) {
                this.onCompleteMethod = this.getParent().onCompleteMethod;
                this.onCompleteArgs = this.getParent().onCompleteArgs;
            }

            if (this.onCloseMethod == null) {
                this.onCloseMethod = this.getParent().onCloseMethod;
                this.onCloseArgs = this.getParent().onCloseArgs;
            }
        }
    },

    'open': function (useHistory) {

        //initialize pop structure
        this.start();

        //configure events
        this.configureEvents();

        //if(positionByEvent == null){
        Pop.setOverlay();
        //}
        //
        var ajaxHandle;

        if (useHistory) {
            ajaxHandle = SendDataByAjaxRunTemplateHistory;
        } else {
            ajaxHandle = SendDataByAjaxRunTemplate;
        }

        try {
            ajaxHandle(
                    this.properties.tpl,
                    this.properties.params,
                    {
                        'callback': Pop.setPopContent,
                        'extra_data' : [this.properties.className]
                    }
                    );
        } catch (e) {
            plog(e);
        }
    },

    'complete': function (auxParam) {
        if (!(this.onCompleteArgs instanceof Array)) {
            this.onCompleteArgs = [this.onCompleteArgs];
        }

        this.onCompleteArgs.push(auxParam);
        if (this.onCompleteMethod != null) {
            this.onCompleteMethod.apply(this, this.onCompleteArgs);
        }
    },

    'close': function () {
        if (this.onCloseMethod != null) {
            this.onCloseMethod.apply(this, [this.onCloseArgs]);
            return;
        }

        if (typeof(this.destroy) != 'undefined') {
            this.destroy();
        }

        if (typeof(this.getParent) != 'undefined' && this.getParent() != null) {
            this.getParent().open();
            return;
        }

        Pop.close();
    },

    'destroy': function () {
        var parent = null;

        if (typeof(this.getParent) != 'undefined') {
            parent = this.getParent();
        }

        if (parent != null) {
            parent['properties'].childs[this.properties.name] = null;
            popCurrent = parent;
            return;
        }

        popCurrent = null;
    }
};

var Pop = {
    'open': function (name, tpl, params, className, events, useHistory, eventHandle) {

        var popInfo = {
            'eventHandle': eventHandle,
            'className': className,
            'events': events,
            'params': params,
            'name': name,
            'tpl': tpl,

            'childs': [],
            'parent': null
        };



        if (typeof(useHistory) == 'undefined') {
            useHistory = false;
        }
        var popObject = new PopObject(popInfo);

        if (popCurrent != null) {
            popObject['properties'].parent = popCurrent;
            popCurrent['properties'].childs[popObject['properties'].name] = popObject;
        }

        popCurrent = popObject;

        popCurrent.open(useHistory);
        return true;
    },

    'setLoader': function () {
        var popContent = jQuery('#pop_content');
        popContent.addClass('unvisible loading');
        popContent.addClass('loading');
        Pop.alignCenter();
        popContent.removeClass('unvisible');
    },

    'setLoaded': function () {
        var popContent = jQuery('#pop_content');
        popContent.addClass('unvisible');
        popContent.removeClass('loading');
        Pop.alignCenter();
        if (popCurrent != null) {
            popContent.removeClass('unvisible');
        }
        adjustInputPlaceholders();
    },

    'setOverlay': function() {
        if (popOverlay.is(':visible')) {
            return true;
        }
        hideActiveX();

        var bodyDimensions;
        try {
            bodyDimensions = jQuery('body').getDimensions();
        } catch(e) {
            bodyDimensions = popGetDimensions('body');
        }
        var viewPortDimensions = viewportPersonare.getWindowDimensions();

        var height = bodyDimensions.height;
        if (bodyDimensions.height < viewPortDimensions.height) {
            height = viewPortDimensions.height;
        }

        popOverlay.css({
            'width': bodyDimensions.width + 'px',
            'height': height + 'px',
            'display': 'block',
            'opacity': 0.7
        });
    },

    'adjustOverlay' : function() {
        if (!popOverlay.is(':visible')) {
            return true;
        }
        var bodyDimensions = jQuery('body').getDimensions();
        var viewPortDimensions = viewportPersonare.getWindowDimensions();

        var height = bodyDimensions.height;
        if (bodyDimensions.height < viewPortDimensions.height) {
            height = viewPortDimensions.height;
        }

        popOverlay.css({
            'width': bodyDimensions.width + 'px',
            'height': height + 'px',
            'display': 'block',
            'opacity': 0.7
        });
    }
            ,

    'setPopContent': function (content, className) {
        var i, l;

        if (!content) {
            return false;
        }

        if ( content.indexOf('var res ') === 0 ) {
            content = eval(content);
        }

        var popContent = jQuery('#pop_content').removeClass().attr('style', '');
        // popContent.children().not('#tmpContent').remove();

        var tmpContent = popContent.children('#tmpContent');

        if ( !tmpContent.length ) {
            tmpContent = jQuery('<div id="tmpContent" class="clearfix"></div>');
            tmpContent.appendTo(popContent);
        }

        tmpContent.siblings().remove();
        tmpContent
                .removeClass()
                .addClass('clearfix')
                .removeAttr('style')
                .empty()
                .append(content);

        if(typeof className != 'string') {
            className = Array.prototype.slice.call(className);
            className = className.join(" ");
        }
        popContent.addClass(className);

        Pop.setOverlay();

        jQuery('#pop_container').show();

        if (popCurrent && popCurrent.properties.eventHandle == null) {
            Pop.alignCenter();
        } else if (popCurrent) {
            Pop.alignTo(popCurrent.properties.eventHandle);
        } else {
            Pop.close();
        }

        Pop.setLoaded();

        jQuery(popOverlay).click( function(e) {
            Pop.close();
            e.preventDefault();
            e.stopPropagation();
            return false;
        });

        jQuery(window)
                .unbind('resize', function() { Pop.alignCenter(); Pop.adjustOverlay(); })
                .bind('resize', function() { Pop.alignCenter(); Pop.adjustOverlay(); });

        adjustInputPlaceholders();

    },
	'alignTo': function (eventHandle) {
        var popContent = jQuery('#pop_content');
        popContent.css({ position : 'absolute' });
        var style = {
            'top': eventHandle.pointerY() + 'px',
            'left': eventHandle.pointerX() + 'px',
            'backgroundColor': '#fff',
            'visibility': 'visible'
        };
        popContent.css(style);
    },

    'alignCenter': function () {
        var popContent = jQuery('#pop_content');

        // if (popContent.length != 1) { alert(popContent.length); return; }

        if (popContent.css('position') !== 'absolute') {
            popContent.css('position','absolute');
        }

        var height = popContent.height();
        var width = popContent.width();

        var halfHeight = height / 2;
        var halfWidth = width / 2;

        var marginTop = '-' + halfHeight + 'px';
        var marginLeft = '-' + halfWidth + 'px';

        var $body = jQuery('body');

        var top = 0;
        var left = '50%';

        if (height > viewportPersonare.getHeight()) {
            marginTop = 0;
            top = 20 + viewportPersonare.getScrollOffsets()[1] + 'px';
        } else {
            top = viewportPersonare.getScrollOffsets()[1] + ((viewportPersonare.getHeight() - height) / 2) + 'px';
        }

        if ($body.height() < viewportPersonare.getHeight()) {
            popOverlay.height(viewportPersonare.getHeight() + 'px');
        } else {
            popOverlay.height($body.height() + 'px');
        }

        popOverlay.width($body.width() + 'px');

        if (height + viewportPersonare.getHeight() > parseInt(popOverlay.height())) {
            popOverlay.height(height + viewportPersonare.getHeight() + 'px');
        }

        var style = {
            'top': top,
            'left': left,
            'marginLeft': marginLeft
        };

        /*if(marginTop != 0){
         style['marginTop'] = marginTop;
         }*/

        popContent.css(style);
        popContent.css({'visibility': 'visible'});
    },

    'close': function (closeCurrent) {
        var popContent = jQuery('#pop_content');

        var tmpContent = popContent.children('#tmpContent');

        tmpContent.siblings().remove();

        tmpContent.empty();

        popContent.removeAttr('style');

        jQuery(window).unbind('resize', function() { Pop.alignCenter(); Pop.adjustOverlay() });

        // Limpar:
        popContainer.hide();
        popOverlay.hide();

        popCurrent = null;

        showActiveX();

        // document.location.hash = '#[close]';

    },

    'sucess': function(title, message, onClose, onComplete) {

        if (onClose == null) {
            onClose = {'method': function (e) {
                plog(e);
            }, 'args': ''}
        }
        if (onComplete == null) {
            onComplete = {'method': function (e) {
                plog(e);
            }, 'args': ''}
        }
        var data = "title=" + title + "&message=" + message;

        Pop.open(
                'PopSucess',
                'Pop/Sucess',
                data, 'default', {'onClose': onClose, 'onComplete': onComplete}
                );

    },

    'error': function(title, message, onClose, onComplete) {

    	if (onClose == null) {
    		onClose = {'method': function (e) {
    			plog(e);
    		}, 'args': ''}
    	}
    	if (onComplete == null) {
    		onComplete = {'method': function (e) {
    			plog(e);
    		}, 'args': ''}
    	}
    	var data = utf8_encode("title=" + title + "&message=" + message);

    	Pop.open(
    			'PopSucess',
    			'Pop/Error',
    			data, 'default', {'onClose': onClose, 'onComplete': onComplete}
    	);

    },

    'confirm': function(title, description, onClose, onComplete) {
        if (onClose == null) {
            onClose = {'method': function (e) {
                alert(e);
            }, 'args': ''};
        }

        if (onComplete == null) {
            onComplete = {'method': function (e) {
                alert(e);
            }, 'args': ''};
        }

        var data = utf8_encode("title=" + title + "&description=" + description);

        Pop.open(
                'PopConfirm',
                'Pop/Confirm',
                data, 'default', {'onClose': onClose, 'onComplete': onComplete}
                );

    }

};
